import React from "react";
import Button from "react-bootstrap/Button";
import clsx from "clsx";
import { Selections } from "../@types";
import { LOCATION } from "../consts";
import {
  DEFAULT_CLOUD_TIME_SELECTION,
  DEFAULT_LOCAL_TIME_SELECTIONS,
  DEFAULT_NETWORK_TIME_SELECTION
} from "../hooks";

interface IClearButton {
  label?: string;
  disabled: boolean;
  location?: string;
  onClick?: (clearedSelections: Selections) => void;
  className?: string;
}

const DEFAULT_LOCATION_TIME_SELECTION = {
  [LOCATION.LOCAL]: DEFAULT_LOCAL_TIME_SELECTIONS,
  [LOCATION.NETWORK]: DEFAULT_NETWORK_TIME_SELECTION,
  [LOCATION.CLOUD]: DEFAULT_CLOUD_TIME_SELECTION
};

const ClearButton: React.FC<IClearButton> = ({
  label = "Clear",
  disabled,
  location,
  onClick,
  className
}) => {
  const handleClick = () => {
    const clearedSelections =
      DEFAULT_LOCATION_TIME_SELECTION[location ?? LOCATION.LOCAL];
    onClick?.(clearedSelections);
  };

  return (
    <Button
      variant="link"
      data-testid="search_toolbar_clear_all"
      disabled={disabled}
      className={clsx("search__clear-all", className)}
      onClick={handleClick}
    >
      {label}
    </Button>
  );
};

export default ClearButton;
